var config =  {
  "us": {
    "chatServer": "wss://chat.rocketman.elbet.us:8765",
    "gameServers": "https://server.rocketman.elbet.us:9223"
  },
  "default": {
    "chatServer": "wss://chat.rocketman.elbet.com:8765",
    "gameServers": "https://server.rocketman.elbet.com:9223"
  }
}

export default config;
